import { Box } from '@mui/material';
import styled from 'styled-components';

import { ContentCardPadding, ContentCardVariant } from '../types';
import { getPaddingObject } from '../utils';

interface FooterProps {
  $showDivider: boolean;
  $padding: ContentCardPadding;
  $variant: ContentCardVariant;
}

const StyledCardFooter = styled(Box)<FooterProps>`
  && {
    padding-top: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).bottom};
    padding-bottom: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).bottom};
    padding-left: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).left};
    padding-right: ${({ theme, $variant, $padding }) =>
      getPaddingObject(theme, $variant, $padding).right};
    ${({ $showDivider, theme }) =>
      $showDivider && `border-top: 1px solid ${theme.palette.divider};`}
  }
`;

export { StyledCardFooter };
